import { buildLink } from '@amazeelabs/react-framework-bridge/gatsby';
import { LocaleCode, useTranslations } from '@nuklear9/i18n';
import { MenuItem } from '@nuklear9/meta';
import { graphql, useStaticQuery } from 'gatsby';

import { buildMenu } from './build-menu';

export const useMetaMenu = (locale: LocaleCode): Array<MenuItem> => {
  const t = useTranslations();
  const { drupalMetaMenu } = useStaticQuery<MetaMenuQuery>(graphql`
    query MetaMenu {
      drupalMetaMenu {
        translations {
          items {
            id
            url
            label
          }
          langcode
        }
      }
    }
  `);
  const menu = drupalMetaMenu?.translations
    ? buildMenu(
        drupalMetaMenu?.translations?.find(
          (translation) => translation.langcode === locale,
        )?.items,
      )
    : [];

  // Define the Gatsby-only menu item
  const gatsbyMenuItem: MenuItem = {
    id: 'gatsby-veranstaltungen',
    title: t('metaMenu.events'),
    Link: buildLink({
      href: locale === 'fr' ? '/fr/evenements/' : '/de/veranstaltungen/',
    }),
  };

  // Insert at 4th position (index 3)
  if (menu.length >= 3) {
    menu.splice(3, 0, gatsbyMenuItem);
  } else {
    menu.push(gatsbyMenuItem);
  }

  return menu;
};
